/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PartnerSyncSearchViewModel {
  /**
   * Sync Update Date Range Start (optional)
   */
  dateRangeStart?: string | null;
  /**
   * Sync Update Date Range End (optional)
   */
  dateRangeEnd?: string | null;
  /**
   * Search Term: patient account number, provider code, or insurance carrier code (optional, max length 50)
   */
  searchTerm?: string | null;
  /**
   * Type of record: Patient, Insurance Carrier, or Provider (optional; must be supplied when search term is specified)
   */
  type?: string | null;
}
